import { TextareaAutosize } from "@mui/material";
import React from "react";
import { capitalizeFirstLetter } from "../../helpers/format";

const TextArea = ({
  name,
  handleChange,
  handleBlur,
  value,
  touched,
  error,
  disabled=false,
  placeholder="",
  helperText,
}: any) => {
  return (
    <>
      <TextareaAutosize
        aria-label="textarea"
        placeholder={placeholder || "enter text here"}
        name={name}
        className={`w-full resize-none h-full pl-2 pt-2 placeholder:pt-2 placeholder:pl-2 focus:outline-none ${
          error && touched ? "border-red-600" : `border-gray-300`
        } border-[1px] rounded`}
        onChange={handleChange}
        onBlur={handleBlur}
        minRows={5}
        maxRows={10}
        value={value}
        disabled={disabled}
      />
      {touched && error && (
        <p className="text-red-600 text-sm mb-2">
          {capitalizeFirstLetter(error)}
        </p>
      )}
    </>
  );
};

export default TextArea;
